// https://www.paintcolourchart.com/ncs-colors/s0502-y.html is used to convert NCS to hex
// swap ncs-code in link to get hex-value
//RAL colors are extracted from https://www.ral-farben.de/en/all-ral-colours


const colors = [
  {
    factoryValueCode: "0502-Y",
    hexCode: "#f3efe3"
  },
  {
    factoryValueCode: "YESWHITE0502Y",
    hexCode: "#f3efe3"
  },
  {
    factoryValueCode: "WHITE_0502Y",
    hexCode: "#f3efe3"
  },
  {
    factoryValueCode: "YESWHITE0500N",
    hexCode: "#ECECE7"
  },
  {
    factoryValueCode: "WHITE_0500N",
    hexCode: "#ECECE7"
  },
  {
    factoryValueCode: "4050-Y90R",
    hexCode: "#89312e"
  },
  { 
    factoryValueCode: "6530-G10Y",
    hexCode: "#16482e"
  },
  {
    factoryValueCode: "6502-Y",
    hexCode: "#66655f"
  },
  {
    factoryValueCode: "6020-R90B",
    hexCode: "#3a546c"
  },
  {
    factoryValueCode: "1030-Y20R",
    hexCode: "#f5c988"
  },
  {
    factoryValueCode: "1040-Y10R",
    hexCode: "#f6ca6f"
  },
  {
    factoryValueCode: "2502-Y",
    hexCode: "#bbb8af"
  },
  {
    factoryValueCode: "5030-B",
    hexCode: "#2e627b"
  },
  {
    factoryValueCode: "1580-Y90R",
    hexCode: "#bd1921"
  },
  {
    factoryValueCode: "7010-Y70R",
    hexCode: "#5d453d"
  },
  {
    factoryValueCode: "2005-G30Y",
    hexCode: "#bdc4ba"
  },
  {
    factoryValueCode: "5020-G70Y",
    hexCode: "#7c7c57"
  },
  {
    factoryValueCode: "6020-B",
    hexCode: "#39586a"
  },
  {
    factoryValueCode: "2040-Y20R",
    hexCode: "#dda65d"
  },
  {
    factoryValueCode: "1502-Y50R",
    hexCode: "#d4cfc8"
  },
  {
    factoryValueCode: "9000-N",
    hexCode: "#191a1b"
  },
  {
    factoryValueCode: "0500-N",
    hexCode: "#f1efeb"
  },
  {
    factoryValueCode: "BRRED_RAL3011",
    hexCode: "#792423"
  },
  {
    factoryValueCode: "WHITE_RAL9010",
    hexCode: "#fcfaf5"
  },
  {
    factoryValueCode: "ASHG_RAL7037",
    hexCode: "#7a7b7a"
  },
  {
    factoryValueCode: "ANTH_RAL7016",
    hexCode: "#4B5054"
  },
  {
    factoryValueCode: "BLACK_RAL9005",
    hexCode: "#3C3C3C"
  },
  {
    factoryValueCode: "OLIVEG_RAL3006",
    hexCode: "#eee9e4"
  },
  {
    factoryValueCode: "NUTBR_RAL8011",
    hexCode: "#5a3826"
  },
  {
    factoryValueCode: "TWIBLUE_RAL5023",
    hexCode: "#42698c"
  },
  {
    factoryValueCode: "6000-N",
    hexCode: "#717170"
  },
  {
    factoryValueCode: "OPTIONAL_COLOR",
    hexCode: 'url("//s.skbv.se/assets/images/lfc/thumbnail-OPTIONAL_COLOR.jpg")'
  },
  { factoryValueCode: "RAL 1000", hexCode: "#CDBA88" },
  { factoryValueCode: "RAL 1001", hexCode: "#D0B084" },
  { factoryValueCode: "RAL 1002", hexCode: "#D2AA6D" },
  { factoryValueCode: "RAL 1003", hexCode: "#F9A900" },
  { factoryValueCode: "RAL 1004", hexCode: "#E49E00" },
  { factoryValueCode: "RAL 1005", hexCode: "#CB8F00" },
  { factoryValueCode: "RAL 1006", hexCode: "#E19000" },
  { factoryValueCode: "RAL 1007", hexCode: "#E88C00" },
  { factoryValueCode: "RAL 1011", hexCode: "#AF8050" },
  { factoryValueCode: "RAL 1012", hexCode: "#DDAF28" },
  { factoryValueCode: "RAL 1013", hexCode: "#E3D9C7" },
  { factoryValueCode: "RAL 1014", hexCode: "#DDC49B" },
  { factoryValueCode: "RAL 1015", hexCode: "#E6D2B5" },
  { factoryValueCode: "RAL 1016", hexCode: "#F1DD39" },
  { factoryValueCode: "RAL 1017", hexCode: "#F6A951" },
  { factoryValueCode: "RAL 1018", hexCode: "#FACA31" },
  { factoryValueCode: "RAL 1019", hexCode: "#A48F7A" },
  { factoryValueCode: "RAL 1020", hexCode: "#A08F65" },
  { factoryValueCode: "RAL 1021", hexCode: "#F6B600" },
  { factoryValueCode: "RAL 1023", hexCode: "#F7B500" },
  { factoryValueCode: "RAL 1024", hexCode: "#BA8F4C" },
  { factoryValueCode: "RAL 1027", hexCode: "#A77F0F" },
  { factoryValueCode: "RAL 1028", hexCode: "#FF9C00" },
  { factoryValueCode: "RAL 1032", hexCode: "#E2A300" },
  { factoryValueCode: "RAL 1033", hexCode: "#F99A1D" },
  { factoryValueCode: "RAL 1034", hexCode: "#EB9C52" },
  { factoryValueCode: "RAL 2000", hexCode: "#DA6E00" },
  { factoryValueCode: "RAL 2001", hexCode: "#BA481C" },
  { factoryValueCode: "RAL 2002", hexCode: "#BF3922" },
  { factoryValueCode: "RAL 2003", hexCode: "#F67829" },
  { factoryValueCode: "RAL 2004", hexCode: "#E25304" },
  { factoryValueCode: "RAL 2008", hexCode: "#EC6B22" },
  { factoryValueCode: "RAL 2009", hexCode: "#DE5308" },
  { factoryValueCode: "RAL 2010", hexCode: "#D05D29" },
  { factoryValueCode: "RAL 2011", hexCode: "#E26E0F" },
  { factoryValueCode: "RAL 2012", hexCode: "#D5654E" },
  { factoryValueCode: "RAL 2017", hexCode: "#FC5500" },
  { factoryValueCode: "RAL 3000", hexCode: "#A72920" },
  { factoryValueCode: "RAL 3001", hexCode: "#9B2423" },
  { factoryValueCode: "RAL 3002", hexCode: "#9B2321" },
  { factoryValueCode: "RAL 3003", hexCode: "#861A22" },
  { factoryValueCode: "RAL 3004", hexCode: "#6B1C23" },
  { factoryValueCode: "RAL 3005", hexCode: "#59191F" },
  { factoryValueCode: "RAL 3007", hexCode: "#3E2022" },
  { factoryValueCode: "RAL 3009", hexCode: "#6D342D" },
  { factoryValueCode: "RAL 3011", hexCode: "#782423" },
  { factoryValueCode: "RAL 3012", hexCode: "#C5856D" },
  { factoryValueCode: "RAL 3013", hexCode: "#972E25" },
  { factoryValueCode: "RAL 3014", hexCode: "#CB7375" },
  { factoryValueCode: "RAL 3015", hexCode: "#D8A0A6" },
  { factoryValueCode: "RAL 3016", hexCode: "#A63D30" },
  { factoryValueCode: "RAL 3017", hexCode: "#CA555D" },
  { factoryValueCode: "RAL 3018", hexCode: "#C63F4A" },
  { factoryValueCode: "RAL 3020", hexCode: "#BB1F11" },
  { factoryValueCode: "RAL 3022", hexCode: "#CF6955" },
  { factoryValueCode: "RAL 3027", hexCode: "#AB273C" },
  { factoryValueCode: "RAL 3028", hexCode: "#CC2C24" },
  { factoryValueCode: "RAL 3031", hexCode: "#A63437" },
  { factoryValueCode: "RAL 4001", hexCode: "#816183" },
  { factoryValueCode: "RAL 4002", hexCode: "#8D3C4B" },
  { factoryValueCode: "RAL 4003", hexCode: "#C4618C" },
  { factoryValueCode: "RAL 4004", hexCode: "#651E38" },
  { factoryValueCode: "RAL 4005", hexCode: "#76689A" },
  { factoryValueCode: "RAL 4006", hexCode: "#903373" },
  { factoryValueCode: "RAL 4007", hexCode: "#47243C" },
  { factoryValueCode: "RAL 4008", hexCode: "#844C82" },
  { factoryValueCode: "RAL 4009", hexCode: "#9D8692" },
  { factoryValueCode: "RAL 4010", hexCode: "#BB4077" },
  { factoryValueCode: "RAL 5000", hexCode: "#304F6E" },
  { factoryValueCode: "RAL 5001", hexCode: "#0E4C64" },
  { factoryValueCode: "RAL 5002", hexCode: "#00387A" },
  { factoryValueCode: "RAL 5003", hexCode: "#1F3855" },
  { factoryValueCode: "RAL 5004", hexCode: "#191E28" },
  { factoryValueCode: "RAL 5005", hexCode: "#005387" },
  { factoryValueCode: "RAL 5007", hexCode: "#376B8C" },
  { factoryValueCode: "RAL 5008", hexCode: "#2B3A44" },
  { factoryValueCode: "RAL 5009", hexCode: "#215F78" },
  { factoryValueCode: "RAL 5010", hexCode: "#004F7C" },
  { factoryValueCode: "RAL 5011", hexCode: "#1A2B3C" },
  { factoryValueCode: "RAL 5012", hexCode: "#0089B6" },
  { factoryValueCode: "RAL 5013", hexCode: "#193153" },
  { factoryValueCode: "RAL 5014", hexCode: "#637D96" },
  { factoryValueCode: "RAL 5015", hexCode: "#007CAF" },
  { factoryValueCode: "RAL 5017", hexCode: "#005B8C" },
  { factoryValueCode: "RAL 5018", hexCode: "#048B8C" },
  { factoryValueCode: "RAL 5019", hexCode: "#005E83" },
  { factoryValueCode: "RAL 5020", hexCode: "#00414B" },
  { factoryValueCode: "RAL 5021", hexCode: "#007577" },
  { factoryValueCode: "RAL 5022", hexCode: "#222D5A" },
  { factoryValueCode: "RAL 5023", hexCode: "#41698C" },
  { factoryValueCode: "RAL 5024", hexCode: "#6093AC" },
  { factoryValueCode: "RAL 6000", hexCode: "#3C7460" },
  { factoryValueCode: "RAL 6001", hexCode: "#366735" },
  { factoryValueCode: "RAL 6002", hexCode: "#325928" },
  { factoryValueCode: "RAL 6003", hexCode: "#50533C" },
  { factoryValueCode: "RAL 6004", hexCode: "#024442" },
  { factoryValueCode: "RAL 6005", hexCode: "#114232" },
  { factoryValueCode: "RAL 6006", hexCode: "#3C392E" },
  { factoryValueCode: "RAL 6007", hexCode: "#2C3222" },
  { factoryValueCode: "RAL 6008", hexCode: "#36342A" },
  { factoryValueCode: "RAL 6009", hexCode: "#27352A" },
  { factoryValueCode: "RAL 6010", hexCode: "#4D6F39" },
  { factoryValueCode: "RAL 6011", hexCode: "#6B7C59" },
  { factoryValueCode: "RAL 6012", hexCode: "#2F3D3A" },
  { factoryValueCode: "RAL 6013", hexCode: "#7C765A" },
  { factoryValueCode: "RAL 6014", hexCode: "#474135" },
  { factoryValueCode: "RAL 6015", hexCode: "#3D3D36" },
  { factoryValueCode: "RAL 6016", hexCode: "#00694C" },
  { factoryValueCode: "RAL 6017", hexCode: "#587F40" },
  { factoryValueCode: "RAL 6018", hexCode: "#60993B" },
  { factoryValueCode: "RAL 6019", hexCode: "#B9CEAC" },
  { factoryValueCode: "RAL 6020", hexCode: "#37422F" },
  { factoryValueCode: "RAL 6021", hexCode: "#8A9977" },
  { factoryValueCode: "RAL 6022", hexCode: "#3A3327" },
  { factoryValueCode: "RAL 6024", hexCode: "#008351" },
  { factoryValueCode: "RAL 6025", hexCode: "#5E6E3B" },
  { factoryValueCode: "RAL 6026", hexCode: "#005F4E" },
  { factoryValueCode: "RAL 6027", hexCode: "#7EBAB5" },
  { factoryValueCode: "RAL 6028", hexCode: "#315442" },
  { factoryValueCode: "RAL 6029", hexCode: "#006F3D" },
  { factoryValueCode: "RAL 6032", hexCode: "#237F52" },
  { factoryValueCode: "RAL 6033", hexCode: "#45877F" },
  { factoryValueCode: "RAL 6034", hexCode: "#7AADAC" },
  { factoryValueCode: "RAL 6037", hexCode: "#008B29" },
  { factoryValueCode: "RAL 6038", hexCode: "#00B51B" },
  { factoryValueCode: "RAL 6039", hexCode: "#B3C43E" },
  { factoryValueCode: "RAL 7000", hexCode: "#7A888E" },
  { factoryValueCode: "RAL 7001", hexCode: "#8C979C" },
  { factoryValueCode: "RAL 7002", hexCode: "#817863" },
  { factoryValueCode: "RAL 7003", hexCode: "#797669" },
  { factoryValueCode: "RAL 7004", hexCode: "#9A9B9B" },
  { factoryValueCode: "RAL 7005", hexCode: "#6B6E6B" },
  { factoryValueCode: "RAL 7006", hexCode: "#766A5E" },
  { factoryValueCode: "RAL 7008", hexCode: "#745F3D" },
  { factoryValueCode: "RAL 7009", hexCode: "#5D6058" },
  { factoryValueCode: "RAL 7010", hexCode: "#585C56" },
  { factoryValueCode: "RAL 7011", hexCode: "#52595D" },
  { factoryValueCode: "RAL 7012", hexCode: "#575D5E" },
  { factoryValueCode: "RAL 7013", hexCode: "#575044" },
  { factoryValueCode: "RAL 7015", hexCode: "#4F5358" },
  { factoryValueCode: "RAL 7016", hexCode: "#383E42" },
  { factoryValueCode: "RAL 7021", hexCode: "#2F3234" },
  { factoryValueCode: "RAL 7022", hexCode: "#4C4A44" },
  { factoryValueCode: "RAL 7023", hexCode: "#808076" },
  { factoryValueCode: "RAL 7024", hexCode: "#45494E" },
  { factoryValueCode: "RAL 7026", hexCode: "#374345" },
  { factoryValueCode: "RAL 7030", hexCode: "#928E85" },
  { factoryValueCode: "RAL 7031", hexCode: "#5B686D" },
  { factoryValueCode: "RAL 7032", hexCode: "#B5B0A1" },
  { factoryValueCode: "RAL 7033", hexCode: "#7F8274" },
  { factoryValueCode: "RAL 7034", hexCode: "#92886F" },
  { factoryValueCode: "RAL 7035", hexCode: "#C5C7C4" },
  { factoryValueCode: "RAL 7036", hexCode: "#979392" },
  { factoryValueCode: "RAL 7037", hexCode: "#7A7B7A" },
  { factoryValueCode: "RAL 7038", hexCode: "#B0B0A9" },
  { factoryValueCode: "RAL 7039", hexCode: "#6B665E" },
  { factoryValueCode: "RAL 7040", hexCode: "#989EA1" },
  { factoryValueCode: "RAL 7042", hexCode: "#8E9291" },
  { factoryValueCode: "RAL 7043", hexCode: "#4F5250" },
  { factoryValueCode: "RAL 7044", hexCode: "#B7B3A8" },
  { factoryValueCode: "RAL 7045", hexCode: "#8D9295" },
  { factoryValueCode: "RAL 7046", hexCode: "#7E868A" },
  { factoryValueCode: "RAL 7047", hexCode: "#C8C8C7" },
  { factoryValueCode: "RAL 8000", hexCode: "#89693F" },
  { factoryValueCode: "RAL 8001", hexCode: "#9D622B" },
  { factoryValueCode: "RAL 8002", hexCode: "#794D3E" },
  { factoryValueCode: "RAL 8003", hexCode: "#7E4B27" },
  { factoryValueCode: "RAL 8004", hexCode: "#8D4931" },
  { factoryValueCode: "RAL 8007", hexCode: "#70462B" },
  { factoryValueCode: "RAL 8008", hexCode: "#724A25" },
  { factoryValueCode: "RAL 8011", hexCode: "#5A3827" },
  { factoryValueCode: "RAL 8012", hexCode: "#66332B" },
  { factoryValueCode: "RAL 8014", hexCode: "#4A3526" },
  { factoryValueCode: "RAL 8015", hexCode: "#5E2F26" },
  { factoryValueCode: "RAL 8016", hexCode: "#4C2B20" },
  { factoryValueCode: "RAL 8017", hexCode: "#442F29" },
  { factoryValueCode: "RAL 8019", hexCode: "#3D3635" },
  { factoryValueCode: "RAL 8022", hexCode: "#1A1719" },
  { factoryValueCode: "RAL 8023", hexCode: "#A45729" },
  { factoryValueCode: "RAL 8024", hexCode: "#795038" },
  { factoryValueCode: "RAL 8025", hexCode: "#755847" },
  { factoryValueCode: "RAL 8028", hexCode: "#513A2A" },
  { factoryValueCode: "RAL 9001", hexCode: "#E9E0D2" },
  { factoryValueCode: "RAL 9002", hexCode: "#D6D5CB" },
  { factoryValueCode: "RAL 9003", hexCode: "#ECECE7" },
  { factoryValueCode: "RAL 9004", hexCode: "#2B2B2C" },
  { factoryValueCode: "RAL 9005", hexCode: "#0E0E10" },
  { factoryValueCode: "RAL 9010", hexCode: "#F1EDE1" },
  { factoryValueCode: "RAL 9011", hexCode: "#27292B" },
  { factoryValueCode: "RAL 9012", hexCode: "#F8F2E1" },
  { factoryValueCode: "RAL 9016", hexCode: "#F1F1EA" },
  { factoryValueCode: "RAL 9017", hexCode: "#29292A" },
  { factoryValueCode: "RAL 9018", hexCode: "#C8CBC4" },
];

export const getHexCode = ( factoryValueCode ) => {
  if (!factoryValueCode) return;

  if (factoryValueCode === "Black matt") return "#0E0E10";
  
  const color = colors
    .filter((colorCodes) => factoryValueCode.split(' ').join('') === colorCodes.factoryValueCode.split(' ').join(''))
    .map((colorCodes) => colorCodes.hexCode);

  return color[0];
};  